export const BOARD_STATUS_GROUPS = Object.freeze(["active_work", "all", "closed_archive"]);
export const DEFAULT_BOARD_STATUS_GROUP = "active_work";

export const normalizeBoardStatusGroup = (value) => {
  const normalized = String(value || "").trim().toLowerCase();
  return BOARD_STATUS_GROUPS.includes(normalized) ? normalized : DEFAULT_BOARD_STATUS_GROUP;
};

export const resolveContractsListViewParam = ({ activeView = "", paymentSubView = "" } = {}) => {
  if (activeView === "payments" && paymentSubView === "due") return "payments_due";
  if (activeView === "board") return "board";
  return undefined;
};

export const resolveContractsStatusGroupParam = ({
  activeView = "",
  status = "",
  boardStatusGroup = DEFAULT_BOARD_STATUS_GROUP,
} = {}) => {
  if (activeView !== "board") return undefined;
  if (String(status || "").trim()) return undefined;
  return normalizeBoardStatusGroup(boardStatusGroup);
};

export const buildContractsListRequestParams = ({
  pagination = {},
  filters = {},
  activeView = "",
  paymentSubView = "",
  boardStatusGroup = DEFAULT_BOARD_STATUS_GROUP,
  sortState = null,
} = {}) => ({
  page: pagination.page,
  limit: pagination.limit,
  search: String(filters.search || "").trim() || undefined,
  status: filters.status || undefined,
  status_group: resolveContractsStatusGroupParam({
    activeView,
    status: filters.status,
    boardStatusGroup,
  }),
  view: resolveContractsListViewParam({ activeView, paymentSubView }),
  sortBy: sortState?.key,
  sortOrder: sortState?.order,
});
